export const UserStatus = {
    pendingActivation: 'PendingActivation',
    active: 'Active',
};

export const InvestorStatus = {
    PendingSelfAccreditation: 'Pending SelfAccreditation',
    PendingNDA: 'Pending NDA',
    PendingKYCSubmission: 'Pending KYCSubmission',
    PendingKYCResubmission: 'Pending KYCResubmission',
    PendingKYCResubmissionReview: 'Pending KYCResubmissionReview',
    PendingKYCReview: 'Pending KYCReview',
    PendingKYCAdditionalDetails: 'Pending KYCAdditionalDetails',
    KYCApproved: 'KYC Approved',
    PendingAISubmission: 'Pending AISubmission',
    PendingAIReview: 'Pending AIReview',
    PendingAIResubmission: 'Pending AIResubmission',
    PendingAIResubmissionReview: 'Pending AIResubmissionReview',
    PendingAIAdditionalDetails: 'Pending AIAdditionalDetails',
    AIApproved: 'AI Approved',
    Rejected: 'Rejected',
    PendingPostAIAgreements: 'Pending PostAIAgreements',
    Approved: 'Approved',
};

export const dealStatus = {
    active: 'Active',
    closed: 'Closed',
    invested: 'Invested',
    completed: 'Completed',
    upcoming: 'Upcoming',
};

export const dealTypes = {
    equity: 'Equity',
    debt: 'Debt',
    fund: 'Fund',
};

export const investmentStatus = {
    PendingPaymentReceipt: 'Pending PaymentReceipt',
    Cancelled: 'Cancelled',
    PendingPaymentConfirmation: 'Pending PaymentConfirmation',
    PaymentReceived: 'PaymentReceived',
    Invested: 'Invested',
    Repaid: 'Repaid',
};

export const supportEmail = 'admin@heli-cap.com';

export const agreementsResign = `We have revised certain agreements applicable to you. Please review the updated terms and sign to acknowledge.`;
